const ActivityType = {
    None: 0,
    Login: 1,
    Logout: 2,
    StartImpersonation: 3,
    StopImpersonation: 4,
    PageVisit: 5,
    ProductPurchase: 6,
    MembershipOnboardingCompleted: 7,
    MembershipActivationSuccess: 8
};

window.addEventListener('load', () => {
    logPageVisit();
});

function sendActivityLog(activityTypeId) {
    if (window.activityLogSettings?.enabled) {
        const activityLogData = {
            activityTypeId: activityTypeId,
            personId: safeValue(wawUserPersonId),
            uuid: getOrCreateSessionUuid(),
            url: window.location.href,
            referrerUrl: getExternalReferrer(),
            statusCode: safeValue(window.wawStatusCode),
            isMobileApp: window.isMobileAppRequest === true
        };

        switch (activityTypeId) {
            case ActivityType.StopImpersonation:
                activityLogData.impersonatedUser = safeValue(window.impersonatedUser);
                break;

            case ActivityType.ProductPurchase:
                activityLogData.orderDetails = buildOrderDetails(window.orderDetails);
                break;

            case ActivityType.PageVisit:
                if (window.activityLogPageMeta) {
                    activityLogData.pageMeta = window.activityLogPageMeta;
                }
                break;
        }

        try {
            $.ajax({
                url: '/api/activitylog/add',
                method: 'POST',
                headers: {
                    'X-WaW-Log-Token': $("#WaWLogToken").val()
                },
                contentType: 'application/json',
                data: JSON.stringify(activityLogData),
                error: function (xhr, status, error) {
                    if (xhr.status === 500 || xhr.status === 400) {
                        console.error('Server error:', xhr.responseText);
                    } else {
                        console.warn('Activity log send failed:', status, error);
                    }
                }
            });
        } catch (err) {
            console.warn('Activity logging failed', err);
        }
    }
}

function getExternalReferrer() {
    try {
        const referrer = document.referrer;
        if (!referrer) return null;

        const referrerHostname = new URL(referrer).hostname;
        const currentHostname = window.location.hostname;

        const idpUrl = $("#AppConfig_AppPaths_IDPURL").val();
        const idpHostname = idpUrl ? new URL(idpUrl).hostname : null;

        if (referrerHostname !== currentHostname && referrerHostname !== idpHostname) {
            return referrer;
        }

        return null;
    } catch (e) {
        return null;
    }
}

function safeValue(value) {
    return (value === undefined || value === null || value === '') ? null : value;
}

function buildOrderDetails(order) {
    try {
        // window.orderDetails is an empty array when no order was found for the page
        if (!order || typeof order !== 'object' || Array.isArray(order)) {
            return null;
        }

        const orderDetails = {
            orderId: safeValue(order.orderID),
            cartId: safeValue(order.cartId),
            customerId: safeValue(order.customerId),
            amount: safeValue(order.amount),
            purchaseDetails: null
        };

        if (Array.isArray(order.purchaseDetails)) {
            orderDetails.purchaseDetails = order.purchaseDetails
                .filter(item => item && typeof item === 'object')
                .map(item => ({
                    productId: safeValue(item.productId),
                    productName: safeValue(item.productName),
                    productSku: safeValue(item.productSKU),
                    price: safeValue(item.price),
                    quantity: safeValue(item.quantity)
                }));
        }

        return orderDetails;
    } catch (err) {
        console.warn('Activity log order details build failed', err);
        return null;
    }
}

function getOrCreateSessionUuid() {
    try {
        const uuidCookie = 'waw_uuid';
        const maxAge = window.activityLogSettings?.uuidCookieExpirySeconds;
        const cookieValue = cookieMap().get(uuidCookie);

        if (cookieValue) {
            setWawUuidCookie(uuidCookie, cookieValue, maxAge);
            return cookieValue;
        }

        const uuid = window.crypto?.randomUUID?.();
        setWawUuidCookie(uuidCookie, uuid, maxAge);
        return uuid;
    } catch {
        return null;
    }
}

function setWawUuidCookie(name, value, maxAgeSeconds) {
    const isLocalhost = location.hostname === "localhost";
    let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;

    if (!isLocalhost) {
        cookie += `; domain=worldatwork.org`;
    }

    document.cookie = cookie;
}


function logPageVisit() {
    // Pages can opt out of page-visit logging for a given render (e.g. a search page that failed
    // reCAPTCHA verification — a likely bot) by setting window.__skipActivityLog = true.
    if (window.__skipActivityLog) return;
    if (window.__activityLogSent) return;
    window.__activityLogSent = true;

    const pageVisitTimeout = Number(window.activityLogSettings?.pageVisitTimeoutMs || 0);

    const send = () => sendActivityLog(ActivityType.PageVisit);

    if (pageVisitTimeout > 0) {
        const timeoutId = setTimeout(send, pageVisitTimeout);
        window.addEventListener('beforeunload', () => clearTimeout(timeoutId));
    } else {
        send();
    }
}
